'use client';
import { createStyles, getSize, rem } from '@s7/styles';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const sizes = {
    xs1: rem(1)
};
const getStrokeStyles = ({ length, spacing, color, orientation, width })=>{
    const isHorizontal = orientation === 'horizontal';
    return {
        [isHorizontal ? 'height' : 'width']: width,
        [isHorizontal ? 'width' : 'height']: '100%',
        backgroundPosition: isHorizontal ? 'bottom' : 'right',
        backgroundRepeat: isHorizontal ? 'repeat-x' : 'repeat-y',
        background: `repeating-linear-gradient(${isHorizontal ? 'to right, ' : 'to bottom, '}${color} 0 ${length}px, transparent ${length}px ${length + spacing}px)`
    };
};
const getDottedStyles = (options)=>{
    return {
        horizontal: getStrokeStyles(_extends({}, options, {
            orientation: 'horizontal',
            length: 1,
            spacing: 6
        })),
        vertical: getStrokeStyles(_extends({}, options, {
            orientation: 'vertical',
            length: 1,
            spacing: 6
        }))
    };
};
const getDashedStyles = (options)=>{
    return {
        horizontal: getStrokeStyles(_extends({}, options, {
            orientation: 'horizontal',
            length: 4,
            spacing: 8
        })),
        vertical: getStrokeStyles(_extends({}, options, {
            orientation: 'vertical',
            length: 4,
            spacing: 8
        }))
    };
};
const getSolidStyles = ({ width, color })=>{
    return {
        horizontal: {
            width: '100%',
            border: 0,
            borderTopWidth: width,
            borderTopColor: color,
            borderTopStyle: 'solid'
        },
        vertical: {
            height: '100%',
            border: 0,
            alignSelf: 'center',
            borderLeftWidth: width,
            borderLeftColor: color,
            borderLeftStyle: 'solid'
        }
    };
};
const strategies = {
    solid: getSolidStyles,
    dotted: getDottedStyles,
    dashed: getDashedStyles
};
const getVariantStyles = (options, variant, hatch)=>{
    if (hatch) {
        const { length, spacing } = hatch;
        return {
            horizontal: getStrokeStyles(_extends({}, options, {
                orientation: 'horizontal',
                length,
                spacing
            })),
            vertical: getStrokeStyles(_extends({}, options, {
                orientation: 'vertical',
                length,
                spacing
            }))
        };
    }
    const strategy = strategies[variant];
    return strategy ? strategy(options) : getSolidStyles(options);
};
var useStyles = createStyles((theme, { color, hatch, withLabel, length, gap = 0 }, { size, variant })=>{
    const { themeColor, primaryShade } = theme.fn;
    const shade = primaryShade(themeColor(color, theme.palette.border.divider));
    const width = getSize({
        size,
        sizes
    });
    const spacing = theme.fn.space(size);
    const computedLength = theme.fn.space(length);
    const { vertical, horizontal } = getVariantStyles({
        width: rem(width),
        color: shade
    }, variant, hatch);
    return {
        root: _extends({
            '&[data-horizontal=true]': _extends({
                margin: theme.fn.space(`0 ${gap}`)
            }, horizontal, length && {
                width: computedLength
            }),
            '&[data-vertical=true]': _extends({
                margin: theme.fn.space(`${gap} 0`)
            }, vertical, !length && {
                alignSelf: 'stretch'
            }, {
                height: length ? computedLength : 'auto'
            })
        }, withLabel && {
            display: 'flex',
            whiteSpace: 'nowrap',
            textAlign: 'center',
            alignItems: 'center',
            border: 0,
            '&::before, &::after': {
                content: '""',
                alignSelf: 'center'
            },
            '&[data-horizontal=true]': _extends({
                margin: theme.fn.space(`0 ${gap}`),
                '&::before, &::after': _extends({
                    width: '100%'
                }, horizontal)
            }, length && {
                width: computedLength
            }),
            '&[data-align=start][data-horizontal=true]': {
                '&::before': {
                    width: '0%'
                },
                '&::after': {
                    width: '100%'
                }
            },
            '&[data-align=end][data-horizontal=true]': {
                '&::before': {
                    width: '100%'
                },
                '&::after': {
                    width: '0%'
                }
            },
            '&[data-vertical=true]': {
                flexDirection: 'column',
                alignSelf: 'stretch',
                height: length ? computedLength : 'auto',
                margin: theme.fn.space(`${gap} 0`),
                '&::before, &::after': _extends({
                    height: '100%'
                }, vertical)
            },
            '&[data-align=start][data-vertical=true]': {
                '&::before': {
                    height: '0%'
                },
                '&::after': {
                    height: '100%'
                }
            },
            '&[data-align=end][data-vertical=true]': {
                '&::before': {
                    height: '100%'
                },
                '&::after': {
                    height: '0%'
                }
            }
        }),
        label: _extends({
            display: 'inline-block',
            color: shade
        }, withLabel && {
            '&[data-align=start][data-horizontal=true]': {
                paddingRight: spacing
            },
            '&[data-align=end][data-horizontal=true]': {
                paddingLeft: spacing
            },
            '&[data-align=center][data-horizontal=true]': {
                paddingRight: spacing,
                paddingLeft: spacing
            },
            '&[data-vertical=true]': {
                paddingTop: spacing,
                paddingBottom: spacing
            }
        })
    };
});

export { useStyles as default };
//# sourceMappingURL=Divider.styles.js.map
